import i18n from 'utility/Translate/I18n';

import { DurationType } from 'types/Search/form';

import { Config } from './types';

export const defaultConfig: Config = {
    defaultValues: {
        daysAmount: 10,
        rangeMinAmount: 5,
        rangeMaxAmount: 8,
    },
    maxDays: 56,
    presetOptions: [
        {
            value: {
                type: DurationType.Exact,
            },
            label: i18n.t('TRANS-exact-travel-dates'),
        },
        {
            value: {
                type: DurationType.Week,
                amount: 1,
            },
        },
        {
            value: {
                type: DurationType.Week,
                amount: 2,
            },
        },
        {
            value: {
                type: DurationType.Week,
                amount: 3,
            },
        },
    ],
    fallback: {
        durationExceeded: {
            type: DurationType.Range,
            min: 6,
            max: 9,
        },
    },
};
